import type { SidebarItem } from '../components/layouts/sidebars/SidebarTypes';

// Permiso de un usuario basic: un ítem del menú (o un grupo de Industria).
export type UserPermission = {
  sidebarItemKey: string;
  enabled: boolean;
  title: string;
  icon?: string;
  readAccess?: string[];
  writeAccess?: string[];
};

// Los permisos que se pueden dar a un usuario basic, armados desde el menú.
// Volumen Exportación solo si la exportadora está suscrita a ASOEX.
export const buildAvailablePermissions = (
  sections: SidebarItem[],
  { hasVolume }: { hasVolume: boolean }
): UserPermission[] => {
  const permissions: UserPermission[] = [];
  sections.forEach((section) => {
    section.items?.forEach((item) => {
      // Ítems con subítems: un permiso por subítem.
      if (item.items && item.items.length > 0) {
        item.items.forEach((subItem) => {
          if (subItem.permissionKey) return; // Hereda el acceso, no es un permiso aparte.
          if (subItem.key === 'industry-volume-group' && !hasVolume) return;
          permissions.push({
            sidebarItemKey: subItem.key,
            enabled: false,
            title: `${item.title} - ${subItem.title}`,
            icon: subItem.icon,
            readAccess: subItem.readAccess,
            writeAccess: subItem.writeAccess,
          });
        });
      } else {
        permissions.push({
          sidebarItemKey: item.key,
          enabled: false,
          title: item.title as string,
          icon: item.icon,
          readAccess: item.readAccess,
          writeAccess: item.writeAccess,
        });
      }
    });
  });
  return permissions;
};

// La lista disponible con los permisos que el usuario ya tiene marcados.
export const withUserPermissions = (
  available: UserPermission[],
  current: { sidebarItemKey: string; enabled: boolean }[] | undefined
) =>
  available.map((p) => ({
    ...p,
    enabled: !!current?.some((c) => c.sidebarItemKey === p.sidebarItemKey && c.enabled),
  }));
